import script from "./buildDetailsRight.vue?vue&type=script&setup=true&lang=ts"
export * from "./buildDetailsRight.vue?vue&type=script&setup=true&lang=ts"

import "./buildDetailsRight.vue?vue&type=style&index=0&id=5cb2e73a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cb2e73a"]])

export default __exports__